/* Postrly motion — scroll reveals, hero scroll transition, subtle parallax.
   Vanilla JS, IntersectionObserver + one rAF loop. Bails entirely under
   prefers-reduced-motion. Content is never hidden unless this file runs
   (CSS gates on html.postrly-motion). */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var doc = document.documentElement;
  doc.classList.add('postrly-motion');

  /* Auto-tag Dawn grids and section titles so stock sections join the rhythm */
  function autoTag(root) {
    (root || document).querySelectorAll('.title-wrapper-with-link, .collection__title').forEach(function (el) {
      if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
    });
    (root || document).querySelectorAll('ul.product-grid, .collection .grid').forEach(function (el) {
      if (!el.hasAttribute('data-reveal-stagger')) el.setAttribute('data-reveal-stagger', '');
    });
  }

  var io = null;
  function observe() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal],[data-reveal-stagger]').forEach(function (el) { el.classList.add('is-inview'); });
      return;
    }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    document.querySelectorAll('[data-reveal],[data-reveal-stagger]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) el.classList.add('is-inview');
      else io.observe(el);
    });
  }

  /* Hero progress + parallax in one rAF-throttled scroll loop */
  var hero = null, plx = [];
  function collect() {
    hero = document.querySelector('[data-hero]');
    plx = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (hero) {
        var hr = hero.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -hr.top / (hr.height * 0.7 || 1)));
        hero.style.setProperty('--hero-p', p.toFixed(3));
      }
      var vh = window.innerHeight;
      for (var i = 0; i < plx.length; i++) {
        var r = plx[i].getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) continue;
        var delta = ((r.top + r.height / 2) - vh / 2) / vh;
        plx[i].style.transform = 'translateY(' + (delta * -22).toFixed(1) + 'px)';
      }
    });
  }

  function init() {
    autoTag();
    observe();
    collect();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
